import { ReactComponent as LicencieLogo } from '../../assets/licencie.svg';
import { ReactComponent as ParrainLogo } from '../../assets/parrain.svg';
import { ReactComponent as Arrow } from '../../assets/arrow.svg';
import { WinnerBanner } from '../WinnerBanner';
import style from './style.module.scss';
import clsx from 'clsx';
import { timerQuiz } from '../utils';

export const HomeTileQuiz = ({ post, isHome = false, isEmailVerified }) => {
    const lockTile =
        !post.hasLevel || !post.hasALicense || !post.isSponsor || post.participate || post.expired || !isEmailVerified;
    const Wrapper = post.expired || lockTile ? 'div' : 'a';
    const link = post.expired || lockTile ? undefined : post.link;
    const areWinners = post.winners.length > 0;

    const winnersMaxLength = 15;

    const winnersList = post.winners.join(', ');

    const winnersPreview =
        areWinners && winnersList.length > winnersMaxLength
            ? winnersList.slice(0, winnersMaxLength) + '...'
            : winnersList;

    return (
        <Wrapper className={clsx(style.block, isHome && style.home, lockTile && style.locked)} href={link}>
            <div className={style.content}>
                <div className={style.gradient} />
                <div
                    className={style.background}
                    style={post.mini_picture && { backgroundImage: 'url(' + post.mini_picture + ')' }}
                />

                <div className={style.container}>
                    <div className={clsx(style.mainContent, areWinners ? style.areWinners : undefined)}>
                        <div className={style.topContent}>
                            <div className={style.timer}>{timerQuiz(post.expiration)}</div>
                            <div className={style.points}>
                                ⭐️ <span>+100</span> Points
                            </div>
                        </div>
                        <div className={style.title} dangerouslySetInnerHTML={{ __html: post.title }} />
                        {lockTile ? (
                            <div
                                className={clsx(
                                    style.action,
                                    'button-myhand-medium button-myhand-disabled',
                                    !isHome && 'button-myhand-fullWidth',
                                )}
                            >
                                {post.expired
                                    ? 'Concours terminé'
                                    : post.participate
                                    ? 'Vous avez déjà participé'
                                    : !isEmailVerified
                                    ? 'Valide ton compte pour participer'
                                    : "Vous n'avez pas le niveau"}
                            </div>
                        ) : (
                            <div
                                className={clsx(
                                    style.action,
                                    'button-myhand-medium',
                                    !isHome && 'button-myhand-fullWidth',
                                )}
                            >
                                Je participe au concours
                            </div>
                        )}
                    </div>

                    {areWinners && (
                        <div className={style.winners}>
                            {winnersPreview.length > winnersMaxLength && (
                                <div className={style.toolTip}>
                                    <p>{winnersList}</p>
                                    <Arrow className={style.arrow} />
                                </div>
                            )}
                            <WinnerBanner winner={winnersPreview} />
                        </div>
                    )}
                </div>
            </div>

            <div className={style.levelOverlay}>
                <div className={style.info}>
                    {post.isRestrictedByRank && (
                        <div className={style.rank}>
                            <div className={style.rankName}>
                                <span>NIVEAU</span>
                                <span>{post.requiredRankName}</span>
                            </div>
                            <div className={style.logoContainer}>
                                <img src={post.requiredRankImage} alt="Logo du niveau requis" />
                            </div>
                        </div>
                    )}
                    {post.isRestrictedToLicenses && (
                        <>
                            <span>LICENCIÉ</span>
                            <div className={style.logoContainer}>
                                <LicencieLogo className={style.logo} />
                            </div>
                        </>
                    )}

                    {post.isRestrictedToSponsors && (
                        <>
                            <span>PARRAIN</span>
                            <div className={style.logoContainer}>
                                <ParrainLogo className={style.logo} />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Wrapper>
    );
};
